var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 34,
    rx: 6,
    fill: "#FFFAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7C17 7 12.5 11.5 12.5 17C12.5 22.5 17 27 22.5 27C28 27 32.5 22.5 32.5 17C32.5 11.5 28 7 22.5 7ZM22.5 25C18.09 25 14.5 21.41 14.5 17C14.5 12.59 18.09 9 22.5 9C26.91 9 30.5 12.59 30.5 17C30.5 21.41 26.91 25 22.5 25ZM27.09 12.58L20.5 19.17L17.91 16.59L16.5 18L20.5 22L28.5 14L27.09 12.58Z",
    fill: "#C56B03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.b1b8a2ef4b2641c72e045cc82d7aeacc.svg";
export { ForwardRef as ReactComponent };